// extracted by mini-css-extract-plugin
export default {"descBox":"FormDescriptionV2_descBox__p3noE","title":"FormDescriptionV2_title__Met0d","bold":"FormDescriptionV2_bold__FrEtv","link":"FormDescriptionV2_link__pKp5Y"};